import {ActionTypes} from '../actions';
import createReducer from '../../common/util/createReducer';


const INITIAL_STATE = {
  'loadingPartNoList': false,
  'partNoList': [],
  'loadingSpecialPartList': false,
  'specialPartList': [],
  'loadingSpecialPart': false,
  'specialPart': {},
  'count': 0,
  'limit': 20,
  'offset': 0,
};

export const specialParts = (state, action) => {
  return createReducer(INITIAL_STATE, {
    [ActionTypes.FETCH_PART_NO_LIST_REQUEST]: (state, action) => ({
      ...state,
      'loadingPartNoList': true,
    }),
    [ActionTypes.FETCH_PART_NO_LIST_FAILED]: (state, action) => ({
      ...state,
      'loadingPartNoList': false,
      'partNoList': [],
    }),
    [ActionTypes.FETCH_PART_NO_LIST_SUCCESS]: (state, action) => ({
      ...state,
      'loadingPartNoList': false,
      'partNoList': action.response.data,
    }),
    [ActionTypes.FETCH_SPECIAL_PART_LIST_REQUEST]: (state, action) => ({
      ...state,
      'loadingSpecialPartList': true,
    }),
    [ActionTypes.FETCH_SPECIAL_PART_LIST_FAILED]: (state, action) => ({
      ...state,
      'loadingSpecialPartList': false,
      'specialPartList': [],
      'count': 0,
    }),
    [ActionTypes.FETCH_SPECIAL_PART_LIST_SUCCESS]: (state, action) => ({
      ...state,
      'loadingSpecialPartList': false,
      'specialPartList': action.response.data,
      'count': action.response.count,
    }),
    [ActionTypes.CLEAR_SPECIAL_PART_LIST]: (state, action) => ({
      ...state,
      'specialPartList': [],
      'count': 0,
      'limit': 20,
      'offset': 0,
    }),
    [ActionTypes.FETCH_SPECIAL_PART_BY_CODE_REQUEST]: (state, action) => ({
      ...state,
      'loadingSpecialPart': true,
    }),
    [ActionTypes.FETCH_SPECIAL_PART_BY_CODE_FAILED]: (state, action) => ({
      ...state,
      'loadingSpecialPart': false,
      'specialPart': {},
    }),
    [ActionTypes.FETCH_SPECIAL_PART_BY_CODE_SUCCES]: (state, action) => ({
      ...state,
      'loadingSpecialPart': false,
      'specialPart': action.response.data,
    }),
    [ActionTypes.CHANGE_SPECIAL_PART_INFORMATION_PAGE]: (state, action) => ({
      ...state,
      'offset': action.payload,
    }),
    [ActionTypes.CHANGE_SPECIAL_PART_INFORMATION_PAGE_SIZE]: (state, action) => ({
      ...state,
      'limit': action.payload,
    }),
  })(state, action);
};
